import React from "react";
import './table.css'

export default function TablePrice({ data }) {  // Деструктуризируем props, ожидая data
    return (
        <table className="table tablePrice">
            <tbody>
                {Array.isArray(data) && data.map((item) => (
                    <tr key={item.id || item.name}>
                        <td>{item.name}</td>
                        <td>{item.price}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

// Значения по умолчанию
TablePrice.defaultProps = {
    data: []  // Пустой массив по умолчанию
};